import { useMemo } from 'react'

import { useFormContext, useWatch } from 'react-hook-form'

import { ControlledSelector, ISelectorOptions } from 'components/common'
import { getSequenceOrderOptions } from 'helpers'
import { TBookingForm } from 'types/form-types'

interface IProps {
  index: number
  isQuickQuote: boolean
  isRequired: boolean
  disabled?: boolean
}
const DeliverySequenceOrder = (props: IProps) => {
  const { index, isQuickQuote, isRequired, disabled } = props

  const {
    control,
    formState: { errors },
  } = useFormContext<TBookingForm>()

  const deliveryAddressesValue = useWatch({ name: 'deliveryAddresses' })

  const deliverySequenceOrder: ISelectorOptions = useMemo(
    () => getSequenceOrderOptions(deliveryAddressesValue, 'Delivery', isQuickQuote),
    [deliveryAddressesValue, isQuickQuote],
  )

  return (
    <ControlledSelector
      emptyValue={{ value: '', label: 'None' }}
      control={control}
      name={`packages.${index}.deliverySequenceOrder`}
      label='Delivery'
      options={deliverySequenceOrder}
      defaultValue=''
      required={isRequired}
      disabled={disabled}
      error={!!errors.packages?.[index]?.deliverySequenceOrder}
      helperText={errors.packages?.[index]?.deliverySequenceOrder?.message}
    />
  )
}

export default DeliverySequenceOrder
